import { SVGProps } from 'react';

const InfoGlyph = ({ width = 20, height = 20, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.107 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0M7.44 10c0-.368.299-.667.667-.667h3c.184 0
        .333.15.333.334V14h.667c.368 0 .666.299.666.667v.666a.667.667 0 0 1-.666.667h-4a.667.667
        0 0 1-.667-.667v-.666c0-.368.299-.667.667-.667h.666v-2.667h-.666a.667.667 0 0 1-.667-.666z"
      fill="currentColor"
    />
  </svg>
);

export default InfoGlyph;
